__webpack_require__.p = "/partner/static/";